"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BranchControllerImpl = void 0;
class BranchControllerImpl {
    subject;
    webAppApi;
    constructor(subject, webAppApi) {
        this.subject = subject;
        this.webAppApi = webAppApi;
    }
    async getBranches(params) {
        // TODO: implement pagination
        const { branches } = await this.webAppApi.getBranches(params);
        branches.forEach(b => this.subject.set(b));
    }
}
exports.BranchControllerImpl = BranchControllerImpl;
